<template>
  <div class="loader-veridens" :class="getClass()">
    <slot></slot>
  </div>
</template>

<script>
  const LOADER_POSITIION = ['absolute', 'relative']

  export default {
    name: 'loader-component',
    props: {
      position: {
        type: String,
        default: LOADER_POSITIION[0]
      }
    },
    methods: {
      getClass () {
        return {
          'loader-absolute': this.position === LOADER_POSITIION[0],
          'loader-relative': this.position === LOADER_POSITIION[1]
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
  @-webkit-keyframes loaderSprite
    from
      background-position: 0px
    to
      background-position: -1700px

  @-moz-keyframes loaderSprite
    from
      background-position: 0px
    to
      background-position: -1700px

  @keyframes loaderSprite
    from
      background-position: 0px
    to
      background-position: -1700px

  .loader-veridens
    width: 100px
    height: 100px
    padding-top: 100px
    background-image: url("../../../assets/images/loader_sprite.png")
    background-size: 1700px 100px
    -webkit-animation: loaderSprite 0.55s steps(17, end) infinite
    -moz-animation: loaderSprite 0.55s steps(17, end) infinite
    animation: loaderSprite 0.55s steps(17, end) infinite
    text-shadow: 2px 2px 8px #000

  .loader-relative
    display: block
    margin: 0px auto

  .loader-absolute
    margin: 0
    position: absolute
    top: 50%
    -ms-transform: translateY(-50%)
    transform: translateY(-50%)
    left: 50%
    -ms-transform: translateX(-50%)
    transform: translateX(-50%)
</style>
